<template>
  <div v-if="info.address !== null && info.address !== undefined" class="col-lg-12 my-3">
    <div class="card p-1 list">

      <div class="row">
        <div class="col-lg-6" >
          <p class="">
            <span v-t="'factor.order_id'"></span>
            {{ info.id }}
          </p>


          <p>
            <b v-t="'factor.user_info.receiver'"></b>
            {{ info.user.name }} {{ info.user.last_name }}
          </p>

        </div>

        <div class="col-lg-6">

          <p dir="ltr">
            {{ dateConverter(info.created_at, '/', true) }}
          </p>

          <p>
            <b v-t="'factor.user_info.cellphone'"></b>
            {{ info.user.cellphone }}
          </p>

        </div>

        <div class="col-lg-12">

          <p>
            <b v-t="'factor.user_info.order_description'"></b>
            {{ info.description }}
          </p>

          <p>
            <b v-t="'factor.user_info.address'"></b>

            <span v-if="info.address.default_address == 0">
                  {{ info.address.province.name }}
                  {{ info.address.city.name }}
                  {{ info.address.address }}
                  ({{ info.address.postal_code }})
                  </span>
            <span v-else>{{ info.address.address }}</span>
            <span v-if=" info.address.description ">
                  ({{ info.address.description }})
                </span>
          </p>
          <p>
            <span class="font-weight-bold" v-t="'factor.user_info.shipment_code'"></span>
            {{ info.shipment_code }}
          </p>
        </div>

      </div>


    </div>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {dateConverter} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter'

export default {
  name: "UserInfo",
  props: {
    info: {}
  },
  methods:{
    formatNumber,
    dateConverter,
  }
}
</script>

<style scoped>

</style>